import { render, staticRenderFns } from "./CDNButton.vue?vue&type=template&id=02b3d56d&scoped=true&"
import script from "./CDNButton.vue?vue&type=script&lang=js&"
export * from "./CDNButton.vue?vue&type=script&lang=js&"
import style0 from "./CDNButton.vue?vue&type=style&index=0&id=02b3d56d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b3d56d",
  null
  
)

export default component.exports